// src/utils/api.js
import { SUBSCRIPTION_ENDPOINTS, AUTH_ENDPOINTS, USER_ENDPOINTS } from "./constants";

export const fetchSubscriptionPlans = async () => {
  try {
    const response = await fetch(SUBSCRIPTION_ENDPOINTS.GET_ALL_PLANS);
    if (!response.ok) {
      throw new Error("Failed to fetch subscription plans");
    }
    const data = await response.json();
    if (data.success && Array.isArray(data.plans)) {
      return data.plans;
    } else {
      throw new Error("Invalid data structure received from API");
    }
  } catch (error) {
    console.error("Error fetching subscription plans:", error);
    throw error;
  }
};

export const registerUser = async (formData, encryptedPassword) => {
  const url = AUTH_ENDPOINTS.REGISTER;
  const data = {
    fullname: `${formData.firstName} ${formData.lastName}`,
    email: formData.email,
    password: formData.password,
    userType: formData.userType,
    encryptPhrase: encryptedPassword,
    planId: formData.planId
  };

  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });

  const result = await response.json();

  if (!result.success) {
    throw new Error(result.message || 'Failed to create account');
  }

  return result;
};